import { render, staticRenderFns } from "./base-film-input-number.vue?vue&type=template&id=20ba9cc2&scoped=true"
import script from "./base-film-input-number.vue?vue&type=script&lang=ts"
export * from "./base-film-input-number.vue?vue&type=script&lang=ts"
import style0 from "./base-film-input-number.vue?vue&type=style&index=0&id=20ba9cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba9cc2",
  null
  
)

export default component.exports